import '../App.css';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { GetItemCommand } from "@aws-sdk/client-dynamodb";
import { docClient } from "../index.js"
import Layout from "../components/Layout";

function Login() {
    const navigate = useNavigate();
    const auth = getAuth();

    const [loginMessage, setLoginMessage] = useState("");
    const [authing, setAuthing] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    

    // Email sign-in
    const signInWithEmail = async () => {
        setAuthing(true)
        setError('')

        signInWithEmailAndPassword(auth, email, password)
            .then(async response => {
                const userId = response.user.uid
                console.log(userId);
                        // Create a user record in DynamoDB
                const command = new GetItemCommand({
                    TableName: "Accounts", // Your DynamoDB table name
                    Key: {
                        UserId: { S: userId }
                    }
                });
            
                const res = await docClient.send(command);

                if (res.Item) {
                    console.log('Item retrieved successfully:', res.Item);
                    if (res.Item.username.S) {
                        localStorage.setItem("isLoggedIn", "true")
                        localStorage.setItem("username", res.Item.username.S)
                        navigate('/')
                    } else {
                        console.log('Cannot find username')
                    }
                } else {
                    console.log('Item not found.');
                }
            })
            .catch(error => {
                console.log(error)
                setError(error.message)
                setAuthing(false);
            });

    }

  return (
    <Layout>
        <h1 className="section-title">Welcome Back</h1>

        <div className="panel auth-panel anim-pop">
            <span className="badge">🐒 Troop Member Login</span>

            <div className="field-stack">
                <input
                    className="input"
                    type="email"
                    id="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    className="input"
                    type="password"
                    id="passwordInput"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>

            {error && <div className="error-bubble">{error}</div>}

            <button
                className="btn btn-xl"
                onClick={signInWithEmail}
                disabled={authing}>
                {authing ? "Swinging in..." : "Login"}
            </button>

            <Link className="link-text" to="/createaccount">Don't have an account? Create one now!</Link>
        </div>
    </Layout>
  );
}

export default Login;
